$(document)
  .on('initFlexSlider', '.flexslider-box', (e) => {
    const $sliderBox = $(e.target);
    const $nav = $sliderBox.find('.features-nav');
    const $sliders = $sliderBox.find('.features-slides');

    // 初始化导航 slider
    $nav.flexslider({
      animation: 'slide',
      controlNav: false,
      directionNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 1,
      asNavFor: '.features-slides',
    });
    // 初始化图片 slider
    $sliders.flexslider({
      animation: 'fade',
      controlNav: false,
      directionNav: false,
      animationLoop: false,
      slideshow: false,
      sync: '.features-nav',
    });
  });

$(() => {
  $('.flexslider-box').trigger('initFlexSlider');
});
